import type React from 'react';
import { useEffect } from 'react';

import { useProgress } from '@/context/progress';
import { usePersonalInformationProgressStep } from '@/features/onboarding/personal-information/hooks/use-progress-step';
import BaseLayout from '@/layouts/base';

const PersonalInformationLayout = (props: React.ComponentPropsWithoutRef<typeof BaseLayout>) => {
  const { setCurrentStep } = useProgress();
  const progressStep = usePersonalInformationProgressStep();

  useEffect(() => {
    return setCurrentStep(progressStep);
  }, [progressStep, setCurrentStep]);

  return <BaseLayout {...props} />;
};
PersonalInformationLayout.displayName = 'PersonalInformationLayout';

export default PersonalInformationLayout;
